import React, { useState, useEffect } from 'react';



 const Spinner = ({size}) => {

  
  return (
    <svg data-testid="loader" xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 40 40">
        <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
            <path fill="#ECECEC" d="M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20Zm0-4c8.837 0 16-7.163 16-16S28.837 4 20 4 4 11.163 4 20s7.163 16 16 16Z"/>
        
            <path fill="#007AB3" d="M39.883 17.83a2 2 0 0 1-3.976.43c-.801-7.414-6.673-13.316-14.08-14.157a2 2 0 0 1 .451-3.974c9.266 1.051 16.604 8.426 17.605 17.7Z">
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    from="0 20 20"
                    to="360 20 20"
                    dur="1s"
                    repeatCount="indefinite"/>
            </path>
        </g>
  
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h40v40H0z"/>
            </clipPath>
        </defs>
    </svg>
  );
}

export default Spinner ;